import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import AboutImg from "../Assets/sign up.jpg";
import Footer from "../Components/Footer";
import SignUpForm from "../Components/SignUpForm";

function SignUp() {
  return (
    <div>
      <Navbar />
      <Hero cName="hero-mid" heroImg={"https://plus.unsplash.com/premium_photo-1666724568420-e282bafa8d2c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Zm9yZXN0c3xlbnwwfHwwfHx8MA%3D%3D"} title="SignUp" />
      <SignUpForm />
      <Footer />
    </div>
  );
}
export default SignUp;
